import { createSlice } from "@reduxjs/toolkit";

const intialUserSettingsState = {
  marketingMailDetails: {},
  securityPinDetails: {},
  settingsLoader: false,
  isSidebarOpen: true,
  archivePreflightData: {},
  archivePreflightLoader: false,
  archiveAccountLoader: false,
  archiveAccountDetails: {},
};

const userSettings = createSlice({
  name: "userSettingDetails",
  initialState: intialUserSettingsState,
  reducers: {
    setSidebarOpen(state, action) {
      state.isSidebarOpen = Boolean(action.payload);
    },
    toggleSidebar(state) {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    getMarketingMailData: (state, action) => {
      state.settingsLoader = true;
      console.log("getMarketingMailData slice", action.payload);
    },
    fetchMarketingMailData: (state, action) => {
      console.log("fetchMarketingMailData slice", action.payload);
      state.settingsLoader = false;
      state.marketingMailDetails = action.payload;
    },
    getSecurityPinData(state, action) {
      state.securityPinDetails = {};
      state.settingsLoader = true;
    },

    fetchSecurityPinData(state, action) {
      state.securityPinDetails = action.payload;
      state.settingsLoader = false;
    },
    clearSecurityPINData(state, action) {
      state.securityPinDetails = {};
      state.settingsLoader = false;
    },
    fetchArchivePreflight: (state) => {
      state.archivePreflightLoader = true;
    },
    setArchivePreflightData: (state, action) => {
      state.archivePreflightLoader = false;
      state.archivePreflightData = action?.payload || {};
    },
    archiveAccount: (state) => {
      state.archiveAccountLoader = true;
    },
    setArchiveAccountDetails: (state, action) => {
      state.archiveAccountLoader = false;
      state.archiveAccountDetails = action?.payload || {};
    },
    clearArchiveAccountData: (state) => {
      state.archivePreflightLoader = false;
      state.archivePreflightData = {};
      state.archiveAccountLoader = false;
      state.archiveAccountDetails = {};
    },
  },
});

export const userSettingsAction = userSettings.actions;
export default userSettings.reducer;
